// src/components/Card.js
import React from 'react';
import { Card as MuiCard, CardContent, CardActions, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@mui/material/styles';
import PlaceIcon from '@mui/icons-material/Place';
import theme from '../theme';
import StyledButton from './StyledButton'; // Assurez-vous que le chemin est correct

const MyCard = ({ item, ...props }) => {
    return (
    <ThemeProvider theme={theme}>   
      <Paper elevation={4} sx={{ display: 'flex', flexDirection: 'column', height: '100%'}}>
      <MuiCard {...props} sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: { xs: '320px', sm: '300px', md: '300px' },}}>
        <CardContent sx={{ flexGrow: 1, paddingBottom:'2px'}}>
          <Typography variant="h6" component="div" sx={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap',
                                        width:'100%',
                                        fontVariantCaps:'all-small-caps'
                                        
                                    }}>
            {item.creneau}
          </Typography>
          <Typography variant="body2" sx={{display:'flex', alignItems:'center',marginBottom:'0.65rem'}}>
           <PlaceIcon  sx={{color:theme.palette.primary.main}}/> {item.lieu}
          </Typography>
          <Typography variant="subtitle1" sx={{marginBottom:'0.65rem'}}>
            <span style={{ backgroundColor: theme.palette.primary.light, color:theme.palette.primary.dark }}>{item.typeDeCours}</span>
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: item.nbPlacesDispo > 0 ? 'bold' : 'normal' , textAlign:'right', color: item.nbPlacesDispo > 0 ? theme.palette.secondary.main : theme.palette.grey.dark}}>
            {item.lblPlacesDispo}
          </Typography>
          <Typography variant="body2" sx={{textAlign:'right'}}>
            {item.lblNbCavaliersInscrits}
          </Typography>
        </CardContent>
        
        <CardActions sx={{ justifyContent: 'flex-end', padding: 1 }}>
          {item.nbPlacesDispo > 0 && (
            
              <StyledButton size="small" onClick={() => window.location.href = `/list-details?recordId=${item.recordId}`}>
                Demande d'inscription
              </StyledButton>
            
          )}
        </CardActions>
        
      </MuiCard>
      </Paper>
    </ThemeProvider>
    );
  };

export default MyCard;
